import { computed, watch, watchEffect } from 'vue'

let subscribedClose = []

const subscribeCloseGlobal = (cb) => {
  subscribedClose.push(cb)
}

const closeSubscribedGlobal = () => {
  subscribedClose.forEach(cb => cb())
  subscribedClose = []
}

export function useOverlay () {
  const visible = useState('site-overlay-visible', () => false)
  const reallyVisible = useState('site-overlay-really-visible', () => false)

  const set = (value) => {
    console.log('[overlay] set →', value, '(was', visible.value, ')')
    visible.value = value
  }

  const reset = () => {
    visible.value = false
    subscribedClose = []
  }

  watchEffect(() => {
    if (visible.value) {
      reallyVisible.value = true
    } else {
      setTimeout(() => {
        reallyVisible.value = false
      }, 600)
    }
  })

  const bodyAttrs = computed(() => reallyVisible.value ? 'blocked' : '')

  useHead(() => ({
    bodyAttrs: {
      class: bodyAttrs
    },
  }))

  const route = useRoute()
  watch(() => route.path, () => {
    reset()
  })

  return {
    visible,
    reallyVisible,
    set,
    subscribeClose: subscribeCloseGlobal,
    closeSubscribed: closeSubscribedGlobal
  }
}
